import DashboardPage from "@/features/dashboard/page";

export default function HomeScreen() {
	return <DashboardPage />;
}
